import { useState } from "react";
import { IoMdAdd, IoMdClose } from "react-icons/io";
import DefaultSearchSelectInput from "./defaultSearchSelectInput";
import DefaultButton from "../buttons/defaultButton";

const DynamicSearchSelectInput = ({
  label = "Approver Flow",
  options = [],
  required = false,
  onChange,
}) => {
  const [rows, setRows] = useState([{ id: Date.now(), value: null }]);

  const updateValue = (id, selected) => {
    const updated = rows.map((r) =>
      r.id === id ? { ...r, value: selected } : r
    );
    setRows(updated);
    onChange(updated.map((x) => x.value));
  };

  const addRow = () => {
    setRows([...rows, { id: Date.now(), value: null }]);
  };

  const removeRow = (id) => {
    const updated = rows.filter((r) => r.id !== id);
    setRows(updated);
    onChange(updated.map((x) => x.value));
  };

  return (
    <div className="flex flex-col gap-3 ">
      <label className="text-theme font-semibold text-sm">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      {rows.map((row, idx) => {
        const isLast = idx === rows.length - 1;

        return (
          <div key={row.id} className="flex flex-row items-center gap-3">
            <DefaultSearchSelectInput
              // label={`${label} ${idx + 1}`}
              name={`${row.id}`}
              value={row.value}
              options={options}
              onChange={(selected) => updateValue(row.id, selected)}
              placeholder="Select designation"
              customWidth="w-full"
              className="w-80"
            />

            {/* Last row → Add button */}
            {isLast ? (
              <DefaultButton
                type="button"
                variant="icon"
                onClick={addRow}
                icon={<IoMdAdd className="text-xl" />}
              />
            ) : (
              <DefaultButton
                variant="danger"
                onClick={() => removeRow(row.id)}
                icon={<IoMdClose className="text-xl" />}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DynamicSearchSelectInput;
